module.exports = __webpack_public_path__ + "img/step-8.2291ed17.jpg";